export const CPM = "CPM";
export const FIXED_PRICE = "FIXED";
